module.exports = __webpack_public_path__ + "img/logo.0327ac48.svg";